import styled from '../theme/styled-components';

export const Main = styled.main`
  flex: 1;
  background-color: ${props => props.theme.colors.typography.light.base};
  ${media => media.theme.media.greaterThan('medium')`
    padding-top: ${props => props.theme.spacings.large};
  `}
`;
